/**
 * @Author: DJ
 * @Date:   2021-08-07 09:51:36
 * @Last Modified by:   DJ
 * @Last Modified time: 2021-08-10 14:13:40
 */
/**
 * 卡片页
 */
import React from 'react';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';

class Main extends React.Component {

    componentDidMount() {
        let pathname = '/home/finance/accountflow';
        http('/?cmd=com.xqxc.api.pig.mis.biz.account.MenuMisService.listMenus&group=mis',{},'POST').then(res=>{
            if(res && res.errCode===0 && res.result){
                for(let m of res.result){
                    if(m.menuUrl === 'finance'){
                        for(let mm of m.children){
                            if(mm.menuUrl === 'platformwallet'){
                                pathname = '/home/finance/platformwallet';
                                break;
                            }
                            
                        }
                         break;
                    }
                   
                }
               
            }
            this.props.history.replace({
                // pathname: '/home/finance/accountflow'
                pathname
            });
        });
    }

    render() {
        return (
            <div></div>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object, // 路由
};

export default Main;